import React, {FunctionComponent} from 'react';
import {useConfigContext, useInputContext} from 'Context';
import {Radio} from 'ui/_Shared';

export const DavMitgliedschaft: FunctionComponent = () => {
    const {input, setInput} = useInputContext();
    const {seite2} = useConfigContext();

    return <Radio label={seite2.frage3.label}
                  value={!!input.davMitgliedschaft ? 'Ja' : 'Nein'}
                  onChangeHandler={value => setInput(input => ({...input, davMitgliedschaft: value === 'Ja'}))}
                  options={[{label: 'Ja', value: 'Ja'}, {label: 'Nein', value: 'Nein'}]}/>;
};
